import { format, isValid } from 'date-fns';
import { useRouter } from 'next/router';

export const useDateTimeRange = () => {
  const router = useRouter();

  const handleDateRangeChange = (newValue, pathname, useISOFormat = false) => {
    const [from, to] = newValue;
    const dateFrom = from && new Date(from);
    const dateTo = to && new Date(to);

    const isValidFrom = isValid(dateFrom);
    const isValidTo = isValid(dateTo);

    const query = {
      ...router.query,
      page: 1,
    };

    if (isValidFrom) {
      query.dateFrom = useISOFormat
        ? dateFrom.toISOString()
        : format(dateFrom, 'yyyy-MM-dd HH:mm:ss');
    } else {
      delete query.dateFrom;
    }

    if (isValidTo) {
      query.dateTo = useISOFormat
        ? dateTo.toISOString()
        : format(dateTo, 'yyyy-MM-dd HH:mm:ss');
    } else {
      delete query.dateTo;
    }

    router.push({ pathname, query });
  };

  return { handleDateRangeChange };
};
